import { observable, action } from 'mobx';

class ContentsStore{

    @observable country = "TT";

    @observable propertyDetails = {
        countrySelect: "",
        constructionType: "",
        daysInhabitedPerYear: 365,
        usedForBusiness: "",
        startMonth: "",
        firstName: "",
        lastName: "",
        email: "",
        mobilePhone: "",
    }

    @observable applicant = {
        firstName:"",
        lastName:"",
        email:"",
        mobilePhone:"",
    }

    @observable property = {
        constructionType:"",
        daysInhabitedPerYear: 365,
        startMonth:"",
        usedForBusiness: false,
    }

    @observable selectedPackage = 0;

    @action async setPropertyDetails(values){
        this.propertyDetails = values;// store to keep values in case navigation backward happens
        
        this.country = values.countrySelect.value;
        this.applicant.firstName = values.firstName;
        this.applicant.lastName = values.lastName;
        this.applicant.email = values.email;
        this.applicant.mobilePhone = values.mobilePhone;
        this.property.constructionType = values.constructionType.value;
        this.property.startMonth = values.startMonth.value;
        this.property.usedForBusiness = values.usedForBusiness.value;

        const axios = await import("axios");
        const url = `${process.env.REACT_APP_API_URL}/contents/quote`;
        const payload = {
            producerCode: values.producerCode,
            country: this.country,
            firstName: this.applicant.firstName,
            lastName: this.applicant.lastName,
            email: this.applicant.email,
            mobilePhone: this.applicant.mobilePhone,
            propertyType: this.property.constructionType,
            startMonth: this.property.startMonth,
            usedForBusiness: this.property.usedForBusiness,
            daysInhabitedPerYear: this.property.daysInhabitedPerYear,
        }

        if (!this.id && !this.quoteId) {
            return axios.post(url, payload).then(({ data, }) => {
                this.id = data.id;
                this.quoteId = data.quoteId;
                return Promise.resolve(data);
            });
        }

        return axios.patch(url, { ...payload, id: this.id, quoteId: this.quoteId }).then(({ data }) => {
            return Promise.resolve(data);
        })
    }

    @action async selectPackage(packageId, annualPremium) {      
        this.selectedPackage = packageId;
        this.selectedPackagePremium = annualPremium;

        const axios = await import("axios");
        const url = `${process.env.REACT_APP_API_URL}/contents/select`;
        const payload = {
            id: this.id,
            quoteId: this.quoteId,
            selectedPackage: packageId,
            selectedPackagePremium: annualPremium,
        };

        return axios.patch(url, payload).then(({ data, }) => Promise.resolve(data));
    }

    @action async saveQuote(values) {
        const axios = await import("axios");
        const url = '/api/?category=home';
        const payload = {
            producerCode: values.producerCode,
            countryName: values.countrySelect.value,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobilePhone: values.mobilePhone,
            propertyType: values.constructionType.value,
            startMonth: values.startMonth.value,
            usedForBusiness: values.usedForBusiness.value,
            coverType: 'Contents',
        };

        if (this.id && this.quoteId) {
            try {
                const { data } = await axios.default.request({
                    method: 'patch',
                    url,
                    data: { ...payload, id: this.id, quoteId: this.quoteId },
                });
                return data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const { data } = await axios.default.request({
                    method: 'post',
                    url,
                    data: payload,
                });
                this.id = data.id;
                this.quoteId = data.quoteId;
                return data;
            } catch (error) {
                throw error;
            }
        }
    }
}

export default ContentsStore;


// WEBPACK FOOTER //
// ./src/store/ContentsStore.js